import { render, staticRenderFns } from "./EditBoxTextarea.vue?vue&type=template&id=43edb856&scoped=true&"
import script from "./EditBoxTextarea.vue?vue&type=script&lang=js&"
export * from "./EditBoxTextarea.vue?vue&type=script&lang=js&"
import style0 from "../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=43edb856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edb856",
  null
  
)

export default component.exports